// src/pages/SuperAdmin/Venues/availabilityApi.js
import api from "../../../components/axiosComp";

// GET list for a day (or a range if your BE supports it)
export async function listAvailability(groundId, params = {}) {
  // params may include { start, end } if needed later; remains backward-compatible
  const { data } = await api.get(
    `/api/superAdmin/grounds/${groundId}/availability`,
    { params },
  );
  return Array.isArray(data?.items)
    ? data.items
    : Array.isArray(data)
      ? data
      : [];
}

export async function getAvailabilityBoard(groundId, params = {}) {
  const { data } = await api.get(
    `/api/superAdmin/grounds/${groundId}/availability-board`,
    { params },
  );
  return data;
}

// POST: block new slot
export async function blockAvailability(groundId, payload) {
  // payload: { date:'YYYY-MM-DD', startTime:'HH:mm', endTime:'HH:mm', reason? }
  const { data } = await api.post(
    `/api/superAdmin/grounds/${groundId}/availability/block`,
    payload,
  );
  return data;
}

export async function blockRecurringAvailability(groundId, payload) {
  const { data } = await api.post(
    `/api/superAdmin/grounds/${groundId}/availability/block-recurring`,
    payload
  );
  return data;
}

// PATCH: edit an existing block
export async function updateAvailability(id, payload) {
  const { data } = await api.patch(
    `/api/superAdmin/availability/${id}`,
    payload,
  );
  return data;
}

// DELETE: unblock
export async function unblockAvailability(id) {
  const { data } = await api.delete(`/api/superAdmin/availability/${id}`);
  return data;
}

export const unblockAvailabilityGroup = async (groupId) => {
  const { data } = await api.delete(`/api/superAdmin/availability/group/${groupId}`);
  return data;
};

export const updateAvailabilityGroup = async (groupId, payload) => {
  const { data } = await api.patch(`/api/superAdmin/availability/group/${groupId}`, payload);
  return data;
};

// READ-ONLY: list admin bookings (availability blocks)
export async function listAdminBookings(params = {}) {
  const { data } = await api.get(`/api/superAdmin/admin-bookings`, { params });
  return {
    items: Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : [],
    total: Number(data?.total) || 0,
    page: Number(data?.page) || Number(params?.page) || 1,
    pageSize: Number(data?.pageSize) || Number(params?.pageSize) || 200,
  };
}


export async function deleteRecurringAvailability(id) {
  const { data } = await api.delete(
    `/api/superAdmin/availability/recurring/${id}`
  );
  return data;
}

export async function updateRecurringAvailability(id, payload) {
  const { data } = await api.patch(
    `/api/superAdmin/availability/recurring/${id}`,
    payload
  );
  return data;
}

export async function createRecurringUnblockException(id, payload) {
  const { data } = await api.post(
    `/api/superAdmin/availability/recurring/${id}/exception-unblock`,
    payload
  );
  return data;
}